import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AlertComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../../core/i18n';
import {
  FloatingSelect,
  type FloatingSelectOption,
} from '../../../../../shared/components/floating-select/floating-select';
import type { PickupTimeOption } from '../mappers/map-pickup-availability';

/** Emitted when either end of the pickup window changes. */
export interface PickupWindowChange {
  from: string | null;
  to: string | null;
}

/**
 * Figma “Select Your Pickup Window” from/to selects (node 19018:57785).
 * Values remain HHmm in state; option labels are localized 12h times.
 */
@Component({
  selector: 'app-pickup-window-section',
  imports: [TypographyComponent, TranslatePipe, FloatingSelect, FormsModule, AlertComponent],
  templateUrl: './pickup-window-section.component.html',
  styleUrl: './pickup-window-section.component.scss',
})
export class PickupWindowSectionComponent {
  readonly fromOptions = input.required<PickupTimeOption[]>();
  readonly toOptions = input.required<PickupTimeOption[]>();
  readonly windowFrom = input<string | null>(null);
  readonly windowTo = input<string | null>(null);
  /** Customer-facing window validation / availability message. */
  readonly windowNotice = input<string | null>(null);

  /** Emits the updated ready/close HHmm pair when either select changes. */
  readonly windowChange = output<PickupWindowChange>();

  /**
   * Maps time options into floating-select option entries.
   */
  protected asSelectOptions(options: PickupTimeOption[]): FloatingSelectOption[] {
    return options.map((option) => ({ value: option.value, label: option.label }));
  }

  /**
   * Emits a window update when the ready (from) time changes.
   */
  onFromChange(value: string | null): void {
    this.windowChange.emit({ from: value, to: this.windowTo() });
  }

  /**
   * Emits a window update when the close (to) time changes.
   */
  onToChange(value: string | null): void {
    this.windowChange.emit({ from: this.windowFrom(), to: value });
  }
}
